import { render, staticRenderFns } from "./ExamTips.vue?vue&type=template&id=6f31b5f2&scoped=true"
import script from "./ExamTips.vue?vue&type=script&lang=js"
export * from "./ExamTips.vue?vue&type=script&lang=js"
import style0 from "./ExamTips.vue?vue&type=style&index=0&id=6f31b5f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f31b5f2",
  null
  
)

export default component.exports